import { LOAD_STATE } from '../../../shared/axios/axios.constants';
import { getTagsByTypeConfig } from './tags.utils';


export const GET_CAMPAIGNS_TAGS_BY_TYPE_REQUEST_CALLED = '@dashboard/tags/GET_CAMPAIGNS_TAGS_BY_TYPE_REQUEST_CALLED';
export const GET_CAMPAIGNS_TAGS_BY_TYPE_REQUEST_SUCCESS = '@dashboard/tags/GET_CAMPAIGNS_TAGS_BY_TYPE_REQUEST_SUCCESS';
export const GET_CAMPAIGNS_TAGS_BY_TYPE_REQUEST_FAIL = '@dashboard/tags/GET_CAMPAIGNS_TAGS_BY_TYPE_REQUEST_FAIL';
export const CREATE_CAMPAIGN_TAG = '@dashboard/tags/CREATE_CAMPAIGN_TAG';


export const getTagsByType = (type: string) => ({
    type: GET_CAMPAIGNS_TAGS_BY_TYPE_REQUEST_CALLED,
    actionTypes: {
        success: GET_CAMPAIGNS_TAGS_BY_TYPE_REQUEST_SUCCESS,
        fail: GET_CAMPAIGNS_TAGS_BY_TYPE_REQUEST_FAIL,
    },
    payload: {
        type,
    },
    config: getTagsByTypeConfig(type),
});

export const createTag = (newTag: {label: string, value: string}, tagsType: string) => ({
    type: CREATE_CAMPAIGN_TAG,
    payload: {
        tagsType,
        newTag,
    },
});

const initialState = {
    loadState: 'loading',
    data: {},
    error: null,
};

export const tagsReducer = (state = initialState, action) => {
    switch (action.type) {
    case GET_CAMPAIGNS_TAGS_BY_TYPE_REQUEST_CALLED:
        return {
            ...state,
            loadState: LOAD_STATE.LOADING,
            data: {},
            error: null,
        };
    case GET_CAMPAIGNS_TAGS_BY_TYPE_REQUEST_SUCCESS:
        return {
            ...state,
            data: {
                ...state.data,
                [action.requestAction.payload.type]: action.payload.data,
            },
            loadState: LOAD_STATE.SUCCESS,
            error: null,
        };
    case GET_CAMPAIGNS_TAGS_BY_TYPE_REQUEST_FAIL:
        return {
            ...state,
            loadState: LOAD_STATE.FAIL,
            error: action.payload,
        };
    case CREATE_CAMPAIGN_TAG:
        return {
            ...state,
            data: {
                ...state.data,
                [action.payload.tagsType]: [
                    action.payload.newTag,
                    ...state.data[action.payload.tagsType],
                ],
            },
            loadState: LOAD_STATE.SUCCESS,
            error: null,
        };
    default:
        return state;
    }
};
